import { CalendarCheck, CalendarRange, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { monthName } from "@/lib/format";
import type { PlanScope } from "@/lib/useBudgetLines";

interface Props { open: boolean; month: string; saving: boolean; onOpenChange: (o: boolean) => void; onPick: (s: PlanScope) => void }

export function ScopeDialog({ open, month, saving, onOpenChange, onPick }: Props) {
  const opts = [
    { scope: "only" as const, Icon: CalendarCheck, title: "Solo este mes", text: `El cambio aplica únicamente a ${monthName(month)}. Los demás meses no cambian.` },
    { scope: "forward" as const, Icon: CalendarRange, title: "De este mes en adelante", text: `Aplica desde ${monthName(month)}. Los meses anteriores no cambian y se respetan los cambios hechos solo para un mes.` },
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white sm:max-w-md" data-testid="scope-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-[#1B2A4A]">¿A qué meses aplica?</DialogTitle>
          <DialogDescription>Los meses pasados se quedan como estaban.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {opts.map(({ scope, Icon, title, text }) => (
            <button key={scope} type="button" disabled={saving} onClick={() => onPick(scope)} data-testid={`scope-${scope}-button`}
              className="flex w-full items-start gap-3 rounded-lg border border-[#DDE1E8] p-4 text-left transition-colors hover:border-[#C9A84C] hover:bg-[#FBF8EF] disabled:opacity-60">
              <Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A84C]" />
              <span><b className="block text-[#1B2A4A]">{title}</b><span className="text-sm text-slate-600">{text}</span></span>
            </button>
          ))}
          {saving && <Loader2 className="mx-auto h-5 w-5 animate-spin text-[#1B2A4A]" data-testid="scope-saving" />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
